import React, { useContext } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useBreakpoints, device } from "../../lib/breakpoints";
import { BackLocationsContext } from "../../context/BackLocationsProvider";
import mixpanel from "mixpanel-browser";

const Logo = ({ color = "black", linkable = true, compact = false }) => {
  const { isMobile, isTabletOrAbove } = useBreakpoints();
  const { clearBackLocations } = useContext(BackLocationsContext);

  const handleNavigation = (path) => {
    clearBackLocations();
    mixpanel.track("Navigation Click", {
      destination: path,
      from_page: location.pathname,
      is_mobile: isMobile,
      is_tablet: isTabletOrAbove,
    });
  };

  const lockup = (
    <LogoContainer $compact={compact}>
      <FaviconImage src="/favicon.ico" alt="SolvTax" $compact={compact} />
      <LogoText $color={color} $compact={compact}>
        <HighlightText>Solv</HighlightText>Tax
      </LogoText>
    </LogoContainer>
  );

  if (!linkable) {
    return lockup;
  }

  return (
    <Link to="/" onClick={() => handleNavigation("/")} style={{ margin: "auto", marginLeft: 0 }}>
      {lockup}
    </Link>
  );
};

export default Logo;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${(p) => (p.$compact ? "5px" : "6px")};
`;

const FaviconImage = styled.img`
  width: ${(p) => (p.$compact ? "22px" : "32px")};
  height: ${(p) => (p.$compact ? "22px" : "32px")};
  object-fit: contain;
  /* Match "Solv" teal #0d9488 */
  filter: brightness(0) saturate(100%) invert(56%) sepia(98%) saturate(500%) hue-rotate(130deg)
    brightness(95%) contrast(91%);

  @media ${device.mobile} {
    width: ${(p) => (p.$compact ? "22px" : "28px")};
    height: ${(p) => (p.$compact ? "22px" : "28px")};
  }
`;

const LogoText = styled.h1`
  font-size: ${(p) => (p.$compact ? "22px" : "32px")};
  font-weight: 700;
  font-family: "Poppins", sans-serif;
  margin: 0;
  color: ${(p) => p.$color};
  letter-spacing: -0.5px;
  line-height: 1.2;

  @media ${device.mobile} {
    font-size: ${(p) => (p.$compact ? "22px" : "28px")};
  }
`;

const HighlightText = styled.span`
  color: #0d9488;
`;
